import React, { useEffect, useRef, useState } from "react";
import MainSectionCard from "../mainsection/MainsectionCard";
import SkeletonComponent from "../SkeletonComponent";
import { API_ENDPOINTS, SITE_URL, toAbsoluteUrl } from "../../assets/helpers/AssetHelpers";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "./childcategory.scss";
import ChildHeader from "./ChildHeader";
import { Image } from "lightbox.js-react";
// import 'lightbox.js-react/dist/index.css';
import useReRouteHook from "../../assets/hooks/useReRouteHook";
import { getCMSCategory, getCMSContent, getCMSPage } from "../../services/api/Api";
import ParentCard from "../parentCard/parentCard";
import MostSearchFaq from "../MostSearchFAQs/MostSearchFaq";
import Circulars from "../Circulars/Circulars";
import JainamLoader, { loaderMessages } from "../common/JainamLoader/JainamLoader";
import { setPageTitle } from "../../utils/setPageTitle";

interface Category {
  new_id: string;
  id: string;
  category_name: string;
  parent_cms_category: string | null;
}
interface ApiResponse {
  data: {
    all_category: Category[];
  };
}
interface CmsContent {
  content_type: string;
  attachment: string | undefined;
  id: string;
  content: string;
}

interface ApiResponse2 {
  data2: {
    all_content: any[];
  };
}
type SubFilteredData = {
  data?: {
    page_title?: string;
    meta_title?: string;
    description?: string;
    hindi_available?: boolean;
    previous?: string;
    next?: string;
    title?: string;
  };
};

const ChildCategory = () => {
  const { reRouteButtonRenderer } = useReRouteHook();
  const [language, setLanguage] = useState<string>("");

  const [data1, setData1] = useState<ApiResponse>({
    data: {
      all_category: [],
    },
  });
  const [data2, setData2] = useState<[]>([]);
  const [cmsCategoryLoading, setCmsCategoryLoading] = useState(true);

  const fetchCMSCategory = async () => {
    try {
      const response = await getCMSCategory(`site=${SITE_URL}`);
      setData1(response);
    } catch (error) {
      console.error("FetchCms Category Error", error);
    } finally {
      setCmsCategoryLoading(false);
    }
  };

  useEffect(() => {
    fetchCMSCategory();
    // fetch(API_ENDPOINTS.getCMSCategory, {
    // 	method: 'POST',
    // 	headers: new Headers({
    // 		'Content-Type': 'application/x-www-form-urlencoded',
    // 	}),
    // 	body: `site=${SITE_URL}`,
    // }).then((result) => {
    // 	result.json().then((resp) => {
    // 		setData1(resp);
    // 	});
    // });
  }, []);

  const [selectedRelatedArticle, setSelectedRelatedArticle] = useState<string | null>(null);
  const { category_name, child_category_name, child, childsub } = useParams();
  const mainTitle = data1.data.all_category.filter((data) => data.new_id === category_name);
  const formattedMainTitle = mainTitle[0]?.category_name;
  const newTitle = data1.data.all_category.filter((data) => data.new_id === child_category_name);
  const formattedNewChildCategoryTitle = newTitle[0]?.category_name;

  const newChildTitle = data1.data.all_category.filter((data) => data.new_id === child);
  const formattedNewChildTitle = newChildTitle[0]?.category_name;
  const fetchCMSContents = async () => {
    try {
      const response = await getCMSContent(`cms_category=${formattedNewChildTitle}`);
      if (response && response.data) {
        setData2(response.data);
      } else {
        console.error("Invalid API response format:", response);
      }
    } catch (error) {
      console.error("Error fetching CMS content:", error);
    }
  };
  useEffect(() => {
    fetchCMSContents();
  }, [formattedNewChildTitle]);

  const getSubcategories = (parentCategory: any, allCategories: any) => {
    const subcategories = allCategories.filter(
      (category: any) => category.parent_cms_category === parentCategory.id,
    );

    if (subcategories.length === 0) {
      return null;
    }
    return subcategories.map((subcategory: any) => ({
      ...subcategory,
      subcategories: getSubcategories(subcategory, allCategories),
    }));
  };
  const nestedCategories = data1?.data?.all_category
    .filter(
      (category: any) =>
        category.parent_cms_category === null || category.parent_cms_category === "",
    )
    .map((category: any) => ({
      ...category,
      subcategories: getSubcategories(category, data1?.data?.all_category),
    }));

  const navigate = useNavigate();

  const handleRelatedArticleClick = (relatedArticleTitle: string) => {
    setSelectedRelatedArticle(relatedArticleTitle);
  };

  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDataLoaded(true);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      const section = document.getElementById("kt_content_container");
      if (section) {
        const offset = window.innerWidth < 1200 ? 76 : 123;
        const sectionPosition = section.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: sectionPosition, behavior: "smooth" });
      }
    }, 200);
    return () => clearTimeout(timer);
  }, [childsub]);

  const [subFilteredData, setSubFilteredData] = useState<SubFilteredData>({});
  const [isCmsPageLoading, setIsCmsPageLoading] = useState(true);
  const hindiAvailable = subFilteredData?.data?.hindi_available || false;
  useEffect(() => {
    console.log("🚀 ~ ChildCategory ~ subFilteredData?.data:", subFilteredData?.data)
    if (subFilteredData?.data) {
      const { page_title, meta_title, description, title } = subFilteredData.data;

      if (meta_title) {
        setPageTitle(meta_title);
      }

      const upsertMetaTag = (attrName: string, attrValue: string, content: string) => {
        let tag = document.querySelector(`meta[${attrName}='${attrValue}']`);
        if (!tag) {
          tag = document.createElement("meta");
          tag.setAttribute(attrName, attrValue);
          document.head.appendChild(tag);
        }
        tag.setAttribute("content", content);
      };

      if (meta_title) {
        upsertMetaTag("name", "title", meta_title);
        upsertMetaTag("property", "og:title", meta_title); // Open Graph title
        upsertMetaTag("name", "twitter:title", meta_title); // Twitter title
      }

      if (description) {
        upsertMetaTag("name", "description", description);
        upsertMetaTag("property", "og:description", description); // Open Graph description
        upsertMetaTag("name", "twitter:description", description); // Twitter description
      }

      // Optionally add URL and type
      const currentUrl = window.location.href;
      upsertMetaTag("property", "og:url", currentUrl);
      upsertMetaTag("property", "og:type", "article"); // or "website"
      upsertMetaTag("name", "twitter:card", "summary"); // or "summary_large_image"

      // Add default image for previews (replace with your actual default image URL)
      upsertMetaTag("property", "og:image", `${SITE_URL}/default-preview.jpg`);
      upsertMetaTag("name", "twitter:image", `${SITE_URL}/default-preview.jpg`);
    }

    return () => {
      setPageTitle("Jainam Support");
      const tagsToClean = [
        "title",
        "description",
        "og:title",
        "og:description",
        "og:url",
        "og:image",
        "twitter:title",
        "twitter:description",
        "twitter:image",
      ];
      tagsToClean.forEach((name) => {
        const tag = document.querySelector(`meta[property='${name}'], meta[name='${name}']`);
        if (tag) tag.remove();
      });
    };
  }, [subFilteredData]);

  const createMetaTag = (name: string) => {
    const tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
    return tag;
  };

  const fetchCmsPage = async () => {
    try {
      setIsCmsPageLoading(true);
      const body = `faq=${encodeURIComponent(childsub || "")}${
        language ? `&content=${encodeURIComponent(language)}` : ""
      }`;
      const response = await getCMSPage(body);
      setSubFilteredData(response);
    } catch (error) {
      console.log("cmspage fatch Error");
    } finally {
      setIsCmsPageLoading(false);
    }
  };

  useEffect(() => {
    fetchCmsPage();

    // fetch(API_ENDPOINTS.getCMSPage, {
    // 	method: 'POST',
    // 	headers: new Headers({
    // 		'Content-Type': 'application/x-www-form-urlencoded',
    // 	}),
    // 	body: `faq=${encodeURIComponent(childsub || '')}${
    // 		language ? `&content=${encodeURIComponent(language)}` : ''
    // 	}`,
    // }).then((result) => {
    // 	result.json().then((resp) => {
    // 		setSubFilteredData(resp);
    // 	});
    // });
  }, [childsub, language]);

  function toggleNavbar(event: { currentTarget: any }) {
    const button = event.currentTarget;
    const isExpanded = button.getAttribute("aria-expanded") === "false";

    if (isExpanded) {
      button.setAttribute("data-bs-state", "closed");
    } else {
      button.setAttribute("data-bs-state", "open");
    }
  }

  if (!category_name || !child_category_name) {
    navigate("/no-results-found");
    return null;
  }

  const handleLanguageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLanguage(e.target.value);
  };

  const previousUrl = subFilteredData?.data?.previous || "";
  const nextUrl = subFilteredData?.data?.next || "";
  return (
    <>
      <section>
        <div className="container d-lg-block d-md-block">
          <div className="row">
            <div className="col mb-lg-5">
              <div className="row">
                <div className="col-lg-11 mx-auto px-4 px-md-5 px-lg-2">
                  <div className="row gx-5">
                    <div className="col-xl-4 mt-4 d-none d-xl-block">
                      <div className="sidebar-sticky">
                        <div className="accordion mt-4" id="sideBarAccordian">
                          {cmsCategoryLoading ? (
                            <SkeletonComponent name={"CategoryCard"} />
                          ) : (
                            nestedCategories.map((category: any, index: any) => (
                              <MainSectionCard
                                key={category.id || category.new_id || index}
                                cards={category}
                                index={index}
                                activeCategoryName={formattedNewChildCategoryTitle}
                                activeCategoryId={child_category_name}
                              />
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                    <nav className="navbar navbar-expand-xl  d-none">
                      <div className="container justify-content-start px-3 px-md-4 px-lg-3">
                        <button
                          className="align-items-center border-0 d-flex fs-18 gap-2 in_reg lh-24 navbar-brand navbar-toggler p-0 pe-3 collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#navbarNavAltMarkup"
                          aria-controls="navbarNavAltMarkup"
                          aria-expanded="false"
                          aria-label="Toggle navigation"
                          onClick={toggleNavbar}
                        >
                          <span className="navbar-toggler-icon"></span>
                          <span>View all categories</span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                          <div className="accordion my-4" id="sideBarAccordian">
                            {cmsCategoryLoading ? (
                              <SkeletonComponent name={"CategoryCard"} />
                            ) : (
                              nestedCategories.map((category: any, index: any) => (
                                <MainSectionCard
                                  key={category.id || category.new_id || index}
                                  cards={category}
                                  index={index}
                                  activeCategoryName={formattedNewChildCategoryTitle}
                                  activeCategoryId={child_category_name}
                                />
                              ))
                            )}
                          </div>
                        </div>
                      </div>
                    </nav>
                    {dataLoaded ? (
                      <div className="col-xl-8 mt-3">
                        <div className="sub-header-sticky">
                          <div className="d-flex">
                            <div className="col-lg-12">
                              <ChildHeader
                                language={language}
                                setLanguage={setLanguage}
                                hindiAvailable={!!subFilteredData?.data?.hindi_available}
                                mainTitle={formattedMainTitle}
                                childCategoryName={formattedNewChildCategoryTitle}
                                childName={formattedNewChildTitle}
                              />
                              {/* <ParentCard /> */}
                            </div>
                          </div>
                        </div>

                        {isCmsPageLoading ? (
                          <JainamLoader messages={loaderMessages.article} />
                        ) : selectedRelatedArticle === null && (
                          <div className="border-bottom htmlcontent mt-1 pb-2">
                            {Object.values(subFilteredData).map(
                              (subItem: any, subIndex: number) => {
                                return (
                                  <div key={subIndex}>
                                    {(language === "hindi"
                                      ? subItem.cms_content_hindi_table
                                      : subItem.cms_content_table
                                    )?.map((item: any, index: number) => {
                                      return (
                                        <div key={index}>
                                          {/* Display Title and Subtitle */}
                                          {/* <div
																						className={
																							index === 0
																								? 'child-cat-title'
																								: 'child-cat-subtitle overflow-x-auto'
																						}
																						dangerouslySetInnerHTML={{
																							__html:
																								(language === 'hindi'
																									? item.content_type_hindi
																									: item.content_type) !== 'Important / Update'
																									? language === 'hindi'
																										? item.editor_hindi
																										: item.content || item.editor
																									: '',
																						}}
																					/> */}
                                          {!["Important / Update", "Best Practices"].includes(
                                            language === "hindi"
                                              ? item.content_type_hindi
                                              : item.content_type,
                                          ) && (
                                            <div
                                              className={
                                                index === 0
                                                  ? "child-cat-title"
                                                  : "child-cat-subtitle"
                                              }
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  language === "hindi"
                                                    ? item.editor_hindi
                                                    : item.content ||
                                                      item.editor ||
                                                      item.html_editor,
                                              }}
                                            />
                                          )}

                                          {/* Handle Video Content */}
                                          {(language === "hindi"
                                            ? item.content_type_hindi
                                            : item.content_type) === "Video" &&
                                            (language === "hindi"
                                              ? item.element_note_hindi
                                              : item.element_note) && (
                                              <p className="text-center">
                                                <>
                                                  {(() => {
                                                    const iframeMatch = (
                                                      language === "hindi"
                                                        ? item.element_note_hindi
                                                        : item.element_note
                                                    ).match(/src="([^"]+)"/);
                                                    const videoSrc = iframeMatch
                                                      ? iframeMatch[1]
                                                      : null;

                                                    return videoSrc ? (
                                                      <div className="iframe-container">
                                                        <iframe
                                                          width="100%"
                                                          height="315"
                                                          src={`${videoSrc}?&rel=0`}
                                                          title="YouTube video player"
                                                          frameBorder="0"
                                                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                          referrerPolicy="strict-origin-when-cross-origin"
                                                          allowFullScreen
                                                          className="rounded-3 responsive-iframe"
                                                        ></iframe>
                                                      </div>
                                                    ) : (
                                                      <p>Video source not found</p>
                                                    );
                                                  })()}
                                                </>
                                              </p>
                                            )}

                                          {/* Handle Image Content */}
                                          {(language === "hindi"
                                            ? item.content_type_hindi
                                            : item.content_type) === "Image" && (
                                            <p className="text-center">
                                              <>
                                                {item.attachment && (
                                                  <Image
                                                    key={`${item.id}-${item.attachment}`}
                                                    image={{
                                                      src: `${process.env.REACT_APP_MEDIA_URL}${item.attachment}`,
                                                    }}
                                                    fullScreen={true}
                                                    className="lightbox-image my-3"
                                                  />
                                                )}
                                              </>
                                            </p>
                                          )}

                                          {/* Handle Video Attachments */}
                                          {/* {item.content_type === 'Video' &&
																									item.attachment && (
																										<p className="text-center">
																											<>
																												<video
																													controls
																													className="video-js rounded-3 video-height my-4">
																													<source
																														src={item.attachment}
																														type="video/mp4"
																													/>
																												</video>
																											</>
																										</p>
																									)} */}
                                          {(language === "hindi"
                                            ? item.content_type_hindi
                                            : item.content_type) === "Video" &&
                                            item.attachment && (
                                              <p className="text-center">
                                                <>
                                                  {item.attachment && (
                                                    <video
                                                      controlsList="nodownload"
                                                      disablePictureInPicture
                                                      controls
                                                      className="video-js rounded-3 video-height my-4"
                                                      // onCanPlayThrough={(event) => {
                                                      // 	event.target.play(); // Automatically play the video once it's fully loaded
                                                      // }}
                                                      onLoadStart={() =>
                                                        console.log("Video is starting to load")
                                                      }
                                                      onWaiting={() =>
                                                        console.log("Video is buffering")
                                                      }
                                                      onLoadedData={() =>
                                                        console.log("Video data has been loaded")
                                                      }
                                                      onError={(e) =>
                                                        console.error("Error loading video", e)
                                                      }
                                                    >
                                                      <source
                                                        src={
                                                          language === "hindi"
                                                            ? `${process.env.REACT_APP_MEDIA_URL}${item.attachment}`
                                                            : `${process.env.REACT_APP_MEDIA_URL}${item.attachment}`
                                                        }
                                                        type={
                                                          item.attachment.endsWith(".webm")
                                                            ? "video/webm"
                                                            : "video/mp4"
                                                        }
                                                      />
                                                    </video>
                                                  )}
                                                </>
                                              </p>
                                            )}

                                          {/* Handle PDF Content */}
                                          {(language === "hindi"
                                            ? item.content_type_hindi
                                            : item.content_type) === "PDF" && (
                                            <>
                                              {item.attachment && (
                                                <a
                                                  className="in_med color1 fs-18"
                                                  href={
                                                    language === "hindi"
                                                      ? `${process.env.REACT_APP_MEDIA_URL}${item.attachment}`
                                                      : `${process.env.REACT_APP_MEDIA_URL}${item.attachment}`
                                                  }
                                                  target="_blank"
                                                  rel="noreferrer"
                                                >
                                                  {item.element_note ? item.element_note : "PDF"}
                                                </a>
                                              )}
                                            </>
                                          )}

                                          {/* Handle Important/Update Content */}
                                          {(language === "hindi"
                                            ? item.content_type_hindi
                                            : item.content_type) === "Important / Update" && (
                                            <>
                                              <div>
                                                <table className="table announcement-table my-3 border-0">
                                                  <thead>
                                                    <tr>
                                                      <th
                                                        scope="col"
                                                        className="faq-announcement-table-title border-0"
                                                      >
                                                        Important Updates
                                                      </th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr>
                                                      <th
                                                        scope="row"
                                                        className="faq-announcement-table-content border-0"
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            language === "hindi"
                                                              ? item.editor_hindi
                                                              : item.editor || item.html_editor,
                                                        }}
                                                      ></th>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </>
                                          )}

                                          {(language === "hindi"
                                            ? item.content_type_hindi
                                            : item.content_type) === "Best Practices" && (
                                            <>
                                              <div>
                                                <table className="table announcement-table my-3 border-0">
                                                  <thead>
                                                    <tr>
                                                      <th
                                                        scope="col"
                                                        className="faq-disclaimer-table-title border-0"
                                                      >
                                                        Best Practices
                                                      </th>
                                                    </tr>
                                                    <tr>
                                                      <td className="faq-disclaimer-table-content border-0 py-1">
                                                        Disclaimer: This is a recommendation only,
                                                        not mandatory.
                                                      </td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr>
                                                      <th
                                                        scope="row"
                                                        className="faq-best-practice-table-content border-0"
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            language === "hindi"
                                                              ? item.editor_hindi
                                                              : item.editor || item.html_editor,
                                                        }}
                                                      ></th>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              },
                            )}
                          </div>
                        )}
                        <div
                          className={`my-4 d-flex ${
                            hindiAvailable ? "justify-content-end" : "justify-content-end"
                          } align-items-center`}
                        >
                          {/* {hindiAvailable && (
                            <div>
                              <div
                                className="btn-group"
                                role="group"
                                aria-label="Language selection"
                              >
                                <input
                                  type="radio"
                                  className="btn-check"
                                  name="language"
                                  id="english"
                                  value=""
                                  checked={language === ""}
                                  onChange={handleLanguageChange}
                                />
                                <label
                                  className="btn lang-btn-check rounded-start-3"
                                  htmlFor="english"
                                >
                                  Eng
                                </label>

                                <input
                                  type="radio"
                                  className="btn-check "
                                  name="language"
                                  id="hindi"
                                  value="hindi"
                                  checked={language === "hindi"}
                                  onChange={handleLanguageChange}
                                />
                                <label className="btn lang-btn-check rounded-end-3" htmlFor="hindi">
                                  हि
                                </label>
                              </div>
                            </div>
                          )} */}
                          <div className="d-flex gap-3 align-items-center">
                            {(previousUrl || isCmsPageLoading) &&
                              reRouteButtonRenderer({
                                url: `/category/${category_name}/${child_category_name}/${child}/${previousUrl}`,
                                classes: "prev-next-button prev-btn",
                                nameText: "Prev",
                                hideTextOnMobile: true,
                                disabled: isCmsPageLoading,
                                startAdornment: (
                                  <img
                                    src={toAbsoluteUrl("child-content/Arrow-Left.svg")}
                                    alt="prev"
                                  />
                                ),
                              })}
                            {(nextUrl || isCmsPageLoading) &&
                              reRouteButtonRenderer({
                                url: `/category/${category_name}/${child_category_name}/${child}/${nextUrl}`,
                                classes: "prev-next-button next-btn",
                                nameText: "Next",
                                hideTextOnMobile: true,
                                applyTransparentBg: false,
                                disabled: isCmsPageLoading,
                                endAdornment: (
                                  <img
                                    src={toAbsoluteUrl("child-content/Arrow-Right.svg")}
                                    alt="next"
                                    className="ms-md-2"
                                  />
                                ),
                              })}
                          </div>
                        </div>
                        <div className="float-end py-2 d-none">
                          Did you find it helpful?
                          <img
                            src={toAbsoluteUrl("child-content/like.png")}
                            className="me-2 ms-2"
                            alt="Like_image"
                          />
                          <img
                            src={toAbsoluteUrl("child-content/dislike.png")}
                            alt="DisLike_image"
                          />
                        </div>

                        {!isCmsPageLoading && Object.values(subFilteredData).map((item: any) => {
                          if (item.cms_related_cms_page && item.cms_related_cms_page.length > 0) {
                            return (
                              <React.Fragment key={item.id}>
                                <h2 className="py-2 bw_reg font1 mt-4" style={{ fontSize: "22px" }}>
                                  Related articles
                                </h2>
                              </React.Fragment>
                            );
                          }
                          return null;
                        })}

                        <div className="row">
                          <div className="col-12">
                            <ul className="px-0">
                              {!isCmsPageLoading && Object.values(subFilteredData).map((item: any) => {
                                return (
                                  item.cms_related_cms_page &&
                                  item.cms_related_cms_page.map((relatedArticle: any) => {
                                    const relatedArticleCmsCategory = relatedArticle.cms_category_id
                                      ? relatedArticle.cms_category_id
                                          .toLowerCase()
                                          .trim()
                                          .replace(/[\s/]+/g, "-")
                                      : "";

                                    return (
                                      <li
                                        key={relatedArticle.id}
                                        className="list-unstyled bw_med"
                                        style={{ padding: "8px 0" }}
                                      >
                                        {reRouteButtonRenderer({
                                          url: `/category/${category_name}/${child_category_name}/${relatedArticleCmsCategory}/${relatedArticle.id}`,
                                          classes: "color1 cursor-pointer in_med subcategory-hover",
                                          nameText:
                                            selectedRelatedArticle === null && relatedArticle.title,
                                        })}
                                        {selectedRelatedArticle === relatedArticle.title && (
                                          <>
                                            {relatedArticle?.cms_content_table?.map(
                                              (contentItem: any, index: any) => (
                                                <div
                                                  key={index}
                                                  dangerouslySetInnerHTML={{
                                                    __html: contentItem?.content,
                                                  }}
                                                />
                                              ),
                                            )}
                                          </>
                                        )}
                                      </li>
                                    );
                                  })
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="col-lg-8">
                        <JainamLoader messages={loaderMessages.article} />
                      </div>
                    )}
                  </div>
                  <div className="row mt-4">
                    <div className="col-12 col-xl-6">
                      <MostSearchFaq />
                    </div>
                    <div className="col-12 col-xl-6">
                      <Circulars />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ChildCategory;
